import { Box } from '@quintoandar-tokko/jopijs';
import RowName from '../components/RowName';
import ProgressBar from '../components/ProgressBar';
import ItemCount from '../components/ItemCount';
import PercentageValue from '../components/PercentageValue';
import styles from './contactSource.module.scss';
import WithoutCategoryTag from '../components/WithoutCategoryTag';

export default function ContactSourceRow({
  id,
  stats = {
    name: '',
    percentage: '',
    contacts: '',
  },
  className = '',
  ...rest
}) {
  const WITHOUT_ORIGIN_ID = 'without_origin';
  const classNames = `${styles.rowWrapper} ${className}`;

  return (
    <Box className={classNames} {...rest}>
      <Box className={styles.contactSourceRow}>
        {id === WITHOUT_ORIGIN_ID ? (
          <WithoutCategoryTag text={stats.name} />
        ) : (
          <RowName text={stats.name} />
        )}
        <ProgressBar percentage={stats.percentage} />
        <ItemCount icon="icon-contactos" value={stats.contacts} />
        <PercentageValue percentage={stats.percentage} />
      </Box>
    </Box>
  );
}
